import type { Action } from 'state/actions';
import type { QuoteDetailsStateMap } from 'state/quotes/details/details.model';
import { addKey, removeKey, removeKeys } from 'state/utils/collection';

import * as actionTypes from '../batchForm.actionTypes';

// TODO: batch screen unit test
export function quoteDetailsReducer(state: QuoteDetailsStateMap = {}, action: Action): QuoteDetailsStateMap {
  switch (action.type) {
    case 'FORM_ENRICHMENT_REQUESTED':
      return removeKey(state, action.formId);
    case actionTypes.BATCH_QUOTE_RECEIVED:
    case actionTypes.BATCH_PREVIOUS_QUOTE_LOADED:
      return addKey(state, action.formId, action.quote.quoteDetails);
    case 'WORKSPACE_TAB_REMOVED':
      return removeKey(state, action.id);
    case actionTypes.BATCH_QUOTE_REMOVED:
      return removeKeys(state, action.formIds);
    default:
      return state;
  }
}
